module.exports = __webpack_public_path__ + "static/media/appmobile4.08710293.webp";